export default class Address {
  public addressTypeId: number
  public street: string
  public postalCode: string
  public city: string
  public country: string
  public streetNumber: string
  public addition?: string
  public contactName?: string
  public contactEmail?: string
  public reference?: string
}



// WEBPACK FOOTER //
// ./src/modules/organization/models/Address.ts